export const APP_KEY = "c629b1edfb8facd0dff7f5fafdace875"
export const APP_SECRET = "806525c6b0587ea20b62556423ae4a14"

// url
export const PAYMENT_URL = "Payment"
export const GETCOININFO_URL = "Coins/GetCoinInfo"
export const CHANGE_URL = "Coins/Change"

// field
export const EMAIL = "email"
export const DEF_PRICE = "def_price"
export const CHECKSUM = "checksum"
export const SITEKEY = "sitekey"
export const RETURNURL = "returnurl"
export const VALUE = "value"
export const BONUS = "bonus"
export const ORDERCODE = "ordercode"



// WEBPACK FOOTER //
// ./src/constants/PaymentApi.js